import styled from 'styled-components';
import { datadogRum } from '@datadog/browser-rum';

import Tooltip, { HelpUnderline } from '#/components/shared/Tooltip';
import Description from '#/components/perpetuals/Description';
import Mono from '#/components/shared/Mono';

import { useMarginSummaryView } from '#/features/account/margin-summary-context';

import useLocalStorage from '#/utils/useLocalStorage';
import useUserStorageKey from '#/utils/useUserStorageKey';

import DescriptionList from './DescriptionList';

export default function MarginSummary() {
  const view = useMarginSummaryView();

  const [isExpanded, setExpanded] = useLocalStorage(
    useUserStorageKey('futures-margin-summary-expanded'),
    true,
  );

  const onToggle = () => setExpanded((prevExpanded) => !prevExpanded);

  return (
    <DescriptionList
      collapsible
      title="Margin"
      expanded={isExpanded}
      onToggle={onToggle}
      onExpandedChange={trackExpansion}
    >
      <Description
        label="Initial Margin"
        value={<Value>{view.initialMarginRequirement}</Value>}
      />
      <Description
        label="Maintenance Margin"
        value={<Value>{view.maintenanceMarginRequirement}</Value>}
      />
      <Description
        label={
          <Tooltip label="Account value / maintenance margin requirements">
            <HelpUnderline>Health Factor</HelpUnderline>
          </Tooltip>
        }
        value={<Value>{view.healthFactor}</Value>}
      />
    </DescriptionList>
  );
}

const Value = styled(Mono)`
  font-size: 11px;
`;

function trackExpansion(isExpanded: boolean) {
  if (isExpanded) {
    datadogRum.addAction('futures-margin-summary-expand');
  } else {
    datadogRum.addAction('futures-margin-summary-collapse');
  }
}
